import _ from "lodash";

export const lodash = _;

export default {
    install : function (Vue) {
        Vue.prototype['$lodash'] = _;
    }
}